import React from 'react';
import PropTypes from 'prop-types';

import FooterBanner from './FooterBanner';
import Testimonials from './Testimonials';
import { PowerFunnelGatedFeatures } from '../../../components/Analytics/constants';

import styles from './powerPerksPage.scss';

const Footer = ({ auth, subscriptionPlans, isLoadingPlans, shouldShowPricing, onPowerClick }) => {
    const handleOnPowerClick = () => {
        onPowerClick(PowerFunnelGatedFeatures.POWER_PERKS_FOOTER);
    };

    return (
        <div className={styles.footer} data-testid="power-perks.footer">
            <div className="container">
                <div className="row">
                    <div className="col">
                        <div className={styles.content}>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12 col-md-10 offset-md-1">
                                        <Testimonials />
                                    </div>
                                </div>
                            </div>
                            <FooterBanner
                                auth={auth}
                                subscriptionPlans={subscriptionPlans}
                                isLoadingPlans={isLoadingPlans}
                                shouldShowPricing={shouldShowPricing}
                                onPowerClick={handleOnPowerClick}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Footer.propTypes = {
    auth: PropTypes.shape({
        user: PropTypes.object,
    }).isRequired,
    subscriptionPlans: PropTypes.arrayOf(PropTypes.object).isRequired,
    isLoadingPlans: PropTypes.bool.isRequired,
    shouldShowPricing: PropTypes.bool.isRequired,
    onPowerClick: PropTypes.func.isRequired,
};

export default Footer;
